import { extendServiceContainer } from '@iotize/tap';
import { GpioService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    gpio: GpioService;
  }
}

export const _TAP_SERVICE_EXTENSION_GPIO_ = extendServiceContainer(
  'gpio',
  GpioService,
);
